'use strict';

import React from 'react';
import { base64encode, utf16to8 } from '../utils'
import ImageWithSpanner from './ImageWithSpanner';

require('styles/MediaArticle.scss');

class BusinessMediaComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render(){
  	let {media,index,watermark} = this.props;
		let {format_desc,images,author} = media;
  	let format_desc_array = format_desc?format_desc.split('\n'):[];
    let origin_imgs = images?images.origin:[];
    let imgs = []
    watermark = base64encode(utf16to8(`@${watermark}`)).replace('/','|');
    origin_imgs&&origin_imgs.map(img => {
      imgs.push(img.replace('!liorigin',`!/fw/750/force/true/watermark/text/${watermark}/size/30/font/simyou/color/FFFFFF/align/southeast/format/png`))
    })
  	let descs = format_desc_array.map((desc,index) => {
			if(desc){
				return (
				<div key={index} className='block'>
					<div className="desc">
						{desc}
					</div>
					{imgs&&imgs[index+1]?(
						<div className="image">
              <ImageWithSpanner onClick={this.props.showPic.bind(this,imgs[index+1])} imageUrl={imgs[index+1]}/>
						</div>
					):''}
				</div>
				)
			} else {
				if(imgs && imgs[index + 1]){
					return (
						<div key={index} className="block">
							<div className="image">
                <ImageWithSpanner onClick={this.props.showPic.bind(this,imgs[index+1])} imageUrl={imgs[index+1]}/>
							</div>
						</div>
					)
				}else{
					return undefined;
				}
			}
  	});

    let moreImgs;
    if(imgs){
      let temp_imgs = imgs.concat();
      let moreImages = temp_imgs.splice(format_desc_array.length + 1,imgs.length);
        
      moreImgs = moreImages.map((img,index) => {
        return (
          <div className="image" key={index}>
            <ImageWithSpanner onClick={this.props.showPic.bind(this,moreImages[index])} imageUrl={moreImages[index]}/>
          </div>
        );
      });
    }

    let nameReveal;
    if(media.name){
      nameReveal = (
        <div className="name">{media.name}</div>
      );
    }

    let addressReveal;
    if(media.formatted_address){
      addressReveal = (
        <div className="address-info">
          <div className="address-tag">地址:</div>
          <div className="address">{media.formatted_address}</div>
        </div>
      );
    }

    return (
      <div className="media-article-component">
        <div className="separator"></div>
        <div className="index">{index+1}</div>
        <div className="media">
          {nameReveal}
          {(imgs&&imgs.length)?(
            <div className="image">
              <ImageWithSpanner onClick={this.props.showPic.bind(this,this,imgs[0])} imageUrl={imgs[0]}/>
            </div>
          ):null}
          {descs}
          {moreImgs}
          {addressReveal}
        </div>
      </div>
    );
  }
}

BusinessMediaComponent.displayName = 'BusinessMediaComponent';

export default BusinessMediaComponent;



// WEBPACK FOOTER //
// ./src/components/BusinessMediaComponent.js